import React, {useEffect, useState} from "react";
import "../Curriculum.css";
import {Button} from "primereact/button";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {SplitButton} from "primereact/splitbutton";
import {QuestionService} from "../../../../../service/QuestionService";
import DeleteConfirmDialog from "../components/DeleteConfirmDialog";
import QuestionForm from "./QuestionForm";
import {Card} from "primereact/card";


const Question = (props) => {
    const {course, chapter, exam, setExam} = props;
    const [data, setData] = useState(exam.questionList ? exam.questionList : []);
    const [body, setBody] = useState(exam.asset?.body);
    const [toggleType, setToggleType] = useState(null); // 'MultipleChoice' | 'TrueFalse' | 'OpenEnded'
    const [activeIndex, setActiveIndex] = useState();
    const [quesitonToDelete, setQuesitonToDelete] = useState(null);
    const [loading, setLoading] = useState(false);

    const service = new QuestionService();

    const items = [
        {
            label: 'Çoktan Seçmeli',
            icon: 'pi pi-list',
            command: () => setToggleType('MultipleChoice')
        },
        {
            label: 'Doğru-Yanlış',
            icon: 'pi pi-book',
            command: () => setToggleType('TrueFalse')
        },
        {
            label: 'Açık Uçlu',
            icon: 'pi pi-file',
            command: () => setToggleType('OpenEnded')
        }
    ];

    useEffect(() => {
        setExam(data);
    }, [data]);


    const addQuestion = (question) => {
        question.exam = exam.id;
        question.objectIndex = data.length + 1;
        service.create(question).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                response.exam = response.exam?.id;
                setData([...data, response]);
                setToggleType(null);
            }
        });
    }

    const updateQuestion = (question) => {
        question.exam = exam.id;
        service.update(question).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                data[response.objectIndex-1] = response;
                setData(prev => prev.map((item, i) => i === response.objectIndex - 1 ? response : item));
                setActiveIndex(-1);
            }
        });
    };

    const deleteQuestion = (id) => {
        service.delete(id).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                setData((prevData) => prevData.filter((question,i)=> question.id !== id));
            }
        });
    };


    const renderView = (question, index) => (
        <div className="flex flex-row gap-2 align-items-center relative">
            <div key={`question-${index}`} className="flex flex-row gap-2 font-normal">
                <p><b>Soru {question.objectIndex}:</b></p>
                <div dangerouslySetInnerHTML={{__html: question.question}}/>
            </div>


            <div className="absolute right-0 gap-4 align-items-center">
                {(index === data.length - 1) && <Button icon="pi pi-fw pi-trash" rounded text severity="danger"
                                                        onClick={() => setQuesitonToDelete(question)}/>}

                <Button icon="pi pi-fw pi-pencil" rounded text severity="secondary"
                        onClick={() => setActiveIndex(index)}/>
            </div>

        </div>
    );


    const renderEdit = (question, index) => (
        <QuestionForm
            chapter={chapter}
            index={index}
            data={question}
            cancel={() => setActiveIndex(-1)}
            save={(question) => updateQuestion(question)}
        />
    );

    const renderTitle = (question, index) => (
        index !== activeIndex
            ? renderView(question, index)
            : renderEdit(question, index)
    );

    return (
        <>
            {data?.sort(GeneralUtils.compareIndex)?.map((question, index) => (
                <Card key={index} title={renderTitle(question, index)} className="question-editor noshadow"/>
            ))}

            {toggleType === null ?
                <div>
                    <SplitButton label="Soru Ekle" icon="pi pi-plus"
                                 onClick={() => setToggleType(toggleType !== 'MultipleChoice' ? 'MultipleChoice' : null)} model={items} outlined
                                 size="small"/>
                </div>
                :
                <Button icon="pi pi-times" rounded text severity="secondary" aria-label="Close"
                        onClick={() => setToggleType(null)}/>
            }


            {toggleType && (
                <QuestionForm chapter={chapter}
                              index={data.length}
                              cancel={() => setToggleType(null)}
                              save={addQuestion}
                              data={{ ...{ questionType: toggleType } }}
                />
            )}

            
            <DeleteConfirmDialog
                itemToDelete={quesitonToDelete}
                onHide={() => setQuesitonToDelete(null)}
                onConfirm={deleteQuestion}
            />
        </>

    )
};

export default Question;
